export default __webpack_public_path__ + "static/media/cap1.d814e261.png";